import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy redirect: /dashboard → /platform
export const Route = createFileRoute('/dashboard')({
  beforeLoad: async () => {
    throw redirect({ to: '/platform' })
  },
  component: () => null,
})
